export default __webpack_public_path__ + "static/media/colombian.171cb996.jpg";